import React from 'react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: "Mike didn't just help me get sober. He helped me figure out who I actually am without the mask. For the first time in 20 years, I feel like I'm living on purpose.",
  author: 'James R.',
  title: 'CEO'
}, {
  quote: 'I came to Mike as a top producer who was secretly falling apart. Six months later, my marriage is healing, my kids trust me again, and I still close deals — just without destroying myself.',
  author: 'David M.',
  title: 'Sales Director'
}, {
  quote: "Working with Mike is like having a conversation with someone who's already been through the war and came back to show you the way out. No judgment. Just truth.",
  author: 'Marcus T.',
  title: 'Entrepreneur'
}];
export function Testimonials() {
  return <section className="py-24 bg-dark-darker relative" data-id="element-158">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-20" data-id="element-160">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-4" data-id="element-161">
            What Clients Say
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-162"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
          {testimonials.map((t, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-charcoal p-8 relative rounded-sm border border-dark-lighter" data-id="element-164">
              {/* Large Quote Mark */}
              <div className="absolute -top-6 left-6 text-6xl text-gold font-serif opacity-50" data-id="element-165">
                "
              </div>

              <p className="text-gray-300 italic text-lg mb-8 relative z-10 pt-4 leading-relaxed" data-id="element-166">
                {t.quote}
              </p>

              <div className="flex items-center" data-id="element-167">
                <div className="w-10 h-1 bg-gold mr-4" data-id="element-168"></div>
                <div data-id="element-169">
                  <div className="text-white font-bold uppercase tracking-wide" data-id="element-170">
                    {t.author}
                  </div>
                  <div className="text-gold text-sm" data-id="element-171">{t.title}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}